import React, { Component } from 'react';

import { Button, Label, IconContainer, BigButtonCheckbox, BigButtonCheckboxSquare } from './style';

const BigButton = ({ isActive = false, onChange = () => { }, icon: Icon, color, label, hasCheckbox = false }) => {
    return (
        <Button active={isActive} onClick={onChange} hasCheckbox={hasCheckbox}>
            <IconContainer>
                {Icon && <Icon />}
            </IconContainer>
            <Label color={color}>{label}</Label>
            {hasCheckbox &&
                <BigButtonCheckbox isActive={isActive}>
                    <BigButtonCheckboxSquare isActive={isActive} />
                </BigButtonCheckbox>
            }
        </Button>
    );
}

export default BigButton;
